import {ADMINS} from 'constant';
import {useAppSelector} from 'store';
import {getPulseUser} from 'store/features/auth/selectors';

export const useAuthUserIsAdmin = () => {
  const curUser = useAppSelector(getPulseUser);
  return curUser && ADMINS.includes(curUser?.email);
};
